import React from "react";
import "../Projects/Project.css"
import { Box, Button } from "@mui/material"
import { Work } from "./ProjectData";

export const Project = () => {

    const [imgUrl, setUrl] = React.useState("")
    const [imgBoolean, setimgBoolean] = React.useState(false)

    // eslint-disable-next-line
    const [x,setx] = React.useState("")
    // eslint-disable-next-line
    const [y,sety] = React.useState("")
    
    
    function mouseEnter(url){
        setUrl(url)
    }
    
    function mouseLeave(){
        setUrl(null)
    }
    
    // var imgDiv = document.getElementById("imgDiv")
    // function handleMouseMove(e){
    //     setx(e.page + "vw")
    //     const x = e.pageX + 'px'
    //     const y = e.pageY + 300 + 'px'
    // }

    const handleMouseMove = event => {
        setx(event.clientX - event.target.offsetLeft)
        sety(event.clientY - event.target.offsetTop)
    };


    React.useEffect(() => {
        if(imgUrl !== null){
            setimgBoolean(true)
        }else{
            setimgBoolean(false)
        }
    },[imgUrl])


    return (
        <>
        <Box className="project" sx={{display:"flex", justfyContent:"center"}} id="Projects">
            <Box className="Box1" sx={{
                width:"23%",
                color:"white",
                padding:"8vw",
                paddingTop:"28vh",
                fontSize:"6vw",
                fontFamily:"'Rozha One', serif"
            }}
            >Projects</Box>


            <Box className="Box2" sx={{
                width:"65%",
                color:"white",
                paddingTop:"26vh",
                paddginLeft:"5vw",
                paddingRight:"5vw",
                zIndex:0,
                background:"transparent",
                backgroundColor:"transparent"
            }}>
                {imgBoolean?
                <Box id="imgDiv" onMouseMove={handleMouseMove} sx={{position:"absolute",top:"370vh", left:"4vw", zIndex:1}}>
                    {/* eslint-disable-next-line */}
                    <img src={imgUrl} className="ProjectImg"/>
                </Box>
                :null}
                { Work.map((items) =>
                // eslint-disable-next-line
                    <a 
                    onMouseEnter={(e) => mouseEnter(items.image)} 
                    onMouseLeave={(e) => mouseLeave()}
                    key={items.id}
                    style={{zIndex:4}}
                    target="_blank" rel="noreferrer" 
                    className="aDiv" id="aDiv">

                        <Box sx={{zIndex:4, borderBottom:1, borderBottomColor:"white", marginBottom:"12vh"}}>
                        <h2 className="heading">{items.name}</h2>
                        <p className="description">{items.description}</p>
                        <p className="tags" style={{marginBottom:"7vh"}}>{items.tags}</p>
                        <Box sx={{marginBottom:'25px'}}>
                            <Button variant="outlined" color="inherit" size="small" sx={{height:'40px'}} onClick={() => window.open(items.github,"_blank")} >Github Repo</Button>
                            <Button variant="outlined" color="inherit" size="small" onClick={() => window.open(items.demo,"_blank")} sx={{height:'40px', marginLeft:"20px"}}>Deploy Link</Button>
                        </Box>
                        {/* <hr style={{marginBottom:"12vh"}} id="hr"/> */}
                        </Box>
                    </a>
                )}
            </Box>
        </Box>
        </>
    )
}